import { render, staticRenderFns } from "./FacilityDetail.vue?vue&type=template&id=db120e38&scoped=true&"
import script from "./FacilityDetail.vue?vue&type=script&lang=js&"
export * from "./FacilityDetail.vue?vue&type=script&lang=js&"
import style0 from "./FacilityDetail.vue?vue&type=style&index=0&id=db120e38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db120e38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
